import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  Box,
  SubHeadingStyled,
  DataContainerHeader,
  ThemeLoader,
} from "../../../components/styled/Elements";
import { SettingsWrapper, FormDataContainer } from "./styled";
import { useNavigate } from "react-router-dom";
import {
  adminDirectorContact,
  adminDirectorInit,
  adminDirectorUploads,
} from "../../../helpers/dummyConstants";
import ViewPage from "../../../components/common/pageView/pageView";
import { Edit, PlaceholderImg } from "../../../components/styled/AllImages";
import ListTable from "../../../components/common/tables/ListTable";
import { tempADaccessColumns } from "../../../helpers/adminConstants/TableConstants";
import AdminDirectorApi from "../../../services/api/adminDirectorApi";

const AdminDirector = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const navigate = useNavigate();
  const [adminDirInit, setAdminDirInit] = useState(adminDirectorInit);
  const [adminDirContact, setAdminDirContact] = useState(adminDirectorContact);
  const [tempADaccessRows, setTempADaccessRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [estUploads, setEstUploads] = useState(adminDirectorUploads);

  const baseAssetURL = process.env.REACT_APP_ASSET_URL;

  const getData = async () => {
    try {
      setLoading(true);

      const response = await AdminDirectorApi.adminDirector();
      if (response?.data) {
        const updateAdminDirInit = adminDirectorInit.map((item) => {
          const key = item.label;
          let updatedText;
          if (key === "name") {
            updatedText = response?.data?.name;
          }
          if (key === "JobRole") {
            updatedText = response?.data?.user_detail?.position;
          }
          if (key === "hq_branches") {
            updatedText = response?.data?.user_detail?.office_location?.name_en;
          }
          if (key === "department") {
            updatedText = response?.data?.user_detail?.department?.name_en;
          }
          return { ...item, text: updatedText };
        });
        setAdminDirInit(updateAdminDirInit);

        const updateAdminDirContact = adminDirectorContact.map((item) => {
          const key = item.label;
          let updatedText;
          if (key === "ContactNo") {
            updatedText = response?.data?.phone;
          }
          if (key === "email") {
            updatedText = response?.data.email;
          }
          return { ...item, text: updatedText };
        });
        setAdminDirContact(updateAdminDirContact);

        const tempAdmins = response.data.temporary_admins || [];
        const usersTempListView = tempAdmins.map((tempAdmin) => ({
          key: tempAdmin.id,
          user: {
            name: tempAdmin.user?.name || "",
            subLabel: `${
              language === "en"
                ? tempAdmin.user.user_detail.department_selective.name_en
                : tempAdmin.user.user_detail.department_selective.name_ar
            } (${
              language === "en"
                ? tempAdmin.user.user_detail.office_location_selective.name_en
                : tempAdmin.user.user_detail.office_location_selective.name_ar
            })`,
            role: tempAdmin.user.user_detail.position,
            image: tempAdmin?.user?.profile
              ? `${baseAssetURL}/${tempAdmin?.user?.profile}`
              : PlaceholderImg,
          },
          startDate: tempAdmin.start_date || "",
          endDate: tempAdmin.end_date || "",
        }));

        setTempADaccessRows(usersTempListView);

        const idUrl = response?.data?.user_detail?.upload_id
          ? `${baseAssetURL}/${response.data.user_detail.upload_id}`
          : null;
        const jobIdUrl = response?.data?.user_detail?.upload_job_id
          ? `${baseAssetURL}/${response.data.user_detail.upload_job_id}`
          : null;
        const updatedEstUploads = adminDirectorUploads.map((item) => {
          if (item.label === "IDJobID") {
            return {
              ...item,
              render: () => (
                <Box className="d-flex gap-3 flex-wrap">
                  {jobIdUrl ? (
                    <Box className="upload-image-full">
                      <img
                        src={jobIdUrl}
                        alt="ID"
                      />
                    </Box>
                  ) : (
                    <span></span>
                  )}
                  {idUrl ? (
                    <Box className="upload-image-full">
                      <img
                        src={idUrl}
                        alt="ID"
                      />
                    </Box>
                  ) : (
                    <span></span>
                  )}
                </Box>
              ),
            };
          }
          return item;
        });
        setEstUploads(updatedEstUploads);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <SettingsWrapper>
      <Box className="content-head">
        <SubHeadingStyled size="16px" color="var(--text)">
          {t("Settings")}
        </SubHeadingStyled>
      </Box>
      {loading ? (
        <ThemeLoader />
      ) : (
        <Box className="content-container">
          <Row className="mt-3">
            <Col md={12}>
              <FormDataContainer className="dataContainer">
                <DataContainerHeader
                  label={t("admin_director")}
                  btnLabel="edit"
                  icon={Edit}
                  onClick={() =>
                    navigate("/settings/admin-director/edit", {
                      state: { tempADaccessRows },
                    })
                  }
                />
                {adminDirInit.map((view, i) => (
                  <ViewPage
                    key={view.id}
                    label={view.label}
                    text={view.text}
                    render={view.render ? view.render : null}
                  />
                ))}
                <Box className="innerFoHead">
                  <SubHeadingStyled size="16px" color="var(--text)">
                    {t("ContactDetails")}
                  </SubHeadingStyled>
                </Box>
                {adminDirContact.map((view, i) => (
                  <ViewPage
                    key={view.id}
                    label={view.label}
                    text={view.text}
                    render={view.render ? view.render : null}
                  />
                ))}
                <Box className="innerFoHead">
                  <SubHeadingStyled size="16px" color="var(--text)">
                    {t("Uploads")}
                  </SubHeadingStyled>
                </Box>
                {estUploads.map((view, i) => (
                  <ViewPage
                    key={view.id}
                    label={view.label}
                    text={view.text}
                    render={view.render ? view.render : null}
                  />
                ))}

                <Box className="innerFoHead">
                  <SubHeadingStyled size="16px" color="var(--text)">
                    {t("TempADaccess")}
                  </SubHeadingStyled>
                </Box>
                <Box>
                  <ListTable
                    rows={tempADaccessRows}
                    columns={tempADaccessColumns}
                    className="tableSecondary"
                  />
                </Box>
              </FormDataContainer>
            </Col>
          </Row>
        </Box>
      )}
    </SettingsWrapper>
  );
};

export default AdminDirector;
